import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal'
import '../../App.css'
import { Button } from '@material-ui/core';
import EditClue from './EditClue'
import firebase from '../../Config/Firebase'
import FileUploader from "react-firebase-file-uploader";
import LinearProgress from '@material-ui/core/LinearProgress';
import imageCompression from 'browser-image-compression';
import generator from 'generate-password'



class App extends Component {

    constructor() {
        super();
        this.state = {
            showus: false,
            change: false,
            shows: false,
            show: false,
            title: "",
            text: "",
            desc: "",
            img: "",
            isUploading: false,
            progress: 0,
            imgurl: "",
            userid: "",
            data: [],
            exist: false,
            clue: {},
            descenter: false,
            delete:false

        }
    }



    handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });
    handleProgress = progress => this.setState({ progress });
    handleUploadError = error => {
        this.setState({ isUploading: false });
        //console.error(error);
    };
    handleUploadSuccess = filename => {
        this.setState({ img: filename, progress: 100, isUploading: false });
        firebase
            .storage()
            .ref(`clues/${this.props.user.groupId}`)
            .child(filename)
            .getDownloadURL()
            .then(url => this.setState({ imgurl: url }));
        //console.log("Image Uploaded")
    };


    openedit(bunch) {
        this.setState({ show: true })
        this.setState({ text: bunch.clueText })
        this.setState({ clue: bunch })
    }

    getclues = () => {
        this.setState({ data: [], show: false }, () => {
            firebase.database().ref(`clue/${this.props.user.id}`).on("child_added", (snapshot) => {
                if (snapshot.exists()) {
                    this.setState({ exist: true })
                    var obj = {
                        clueId: snapshot.val().clueId,
                        clueImage: snapshot.val().clueImage,
                        clueText: snapshot.val().clueText,
                        userid: this.props.user.id
                    }

                    const previousList = this.state.data;
                    previousList.push(obj)
                    this.setState({
                        data: previousList
                    }, () => {
                        this.setState({ loading: false })
                    });
                    //console.log(this.state.data,"clue")
                }
                else {
                    this.setState({ data: [] })
                    //console.log(this.state.data,"ssfs")
                }
            })
        })
    }

    handleImageUpload(event) {
        let self = this;
        var userid = this.state.userid;
        var password = generator.generate({
            length: 15,
            numbers: true
        });
        this.setState({ isUploading: true })
        var imageFile = event.target.files[0];
        //console.log('originalFile instanceof Blob', imageFile instanceof Blob); // true
        //console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

        var options = {
            maxSizeMB: 0.3,
            maxWidthOrHeight: 1920,
            useWebWorker: true
        }
        imageCompression(imageFile, options)
            .then(function (compressedFile) {
                //console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
                //console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
                var storageRef = firebase.storage().ref(`clues/${userid}`)
                var task = storageRef.child(password).put(compressedFile);
                task.on('state_changed', (snapshot) => {
                    var progress = Math.round(100 * snapshot.bytesTransferred / snapshot.totalBytes);
                    self.setprogress(progress)
                }, function (error) {
                    //console.log(error,"imguploaderror")
                }, function () {
                    self.handleUploadSuccess(password)
                })
                // write your own logic
            })
            .catch((error) => {
                //console.log(error.message);
            });

    }

    setprogress = (p) => {
        this.setState({ progress: p })
    }





    componentWillReceiveProps(props) {

        this.setState({ showus: props.open })
        this.setState({ userid: props.user.groupId })
        //console.log("userid is this ",this.state.userid)
        this.getclues()
        //console.log(props.user,"userr")

    }

    addclue = () => {
        if (this.state.desc !== "") {
            var myRef = firebase.database().ref(`clue/${this.props.user.id}`).push();
            var key = myRef.key;

            var newData = {
                clueId: key,
                clueImage: this.state.imgurl,
                clueText: this.state.desc
            }

            myRef.set(newData);
            this.setState({ shows: false, imgurl: "", desc: "" })
            this.getclues()
        }
        else {
            this.setState({ descenter: true })
            setTimeout(() => {
                this.setState({ descenter: false })
            }, 3000);
        }
    }

    deleteclue=(clue)=>{
        var del = firebase.database().ref(`clue/${clue.userid}/${clue.clueId}`);
        del.remove()
        this.getclues()
        this.setState({delete:false})
}

    render() {



        return (
            <div style={{ marginTop: "100px" }}>
                <Modal
                    show={this.state.showus}
                    onHide={this.props.onHide}
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                // backdrop={"static"}
                >
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Clues
              </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="modal-body">
                        <div className="in">
                            {this.state.data.map((bunch) => {

                                return (

                                    <div className="card" style={{ marginBottom: "10px" }}>

                                        <div className="row no-gutters">
                                            <div className="col-auto">
                                                {bunch.clueImage === "" ? (<img src="http://canamerica.adsfreevideos.com/upload/noimage.jpg" className="img-fluid" width={300} alt="" />) :
                                                    <img src={bunch.clueImage} className="img-fluid" width={300} alt="" />}
                                            </div>
                                            <div className="col">
                                                <div className="card-block px-2">
                                                    {/* <h4 className="card-title">Title</h4> */}
                                                    <p className="card-text">{bunch.clueText} </p>
                                                    <button className="btn btn-primary" onClick={() => { this.openedit(bunch) }}>Edit</button>
                                                    <button style={{marginLeft:"10px"}} className="btn btn-danger" onClick={()=>this.setState({delete:true,clue:bunch})}>Delete</button>
                                                   
                                                </div>
                                            </div>
                                        </div>


                                    </div>)
                            })}


                        </div>{this.state.exist === false && <div style={{ textAlign: "center" }}>
                            <p>No Clues Yet</p>
                            <p>Press <b>Add Clue</b> To Add A New Clue</p>
                        </div>}
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-primary" onClick={() => {
                            this.setState({ shows: true }); this.setState({ showuse: false }); this.setState({ show: false })
                        }}>Add Clue</button>
                        <button onClick={() => { this.setState({ showus: false }); this.setState({ show: false }); this.setState({ exist: false }) }} className="btn btn-danger">Close</button>
                    </Modal.Footer>
                </Modal>
                <Modal

                    show={this.state.shows}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    backdrop={"static"}
                >
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Add Clue
              </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ height: "33vh" }}>
                        <form className="md-form">
                            {/* <div class="file-field">
    <div class="btn btn-primary btn-xl" style={{width:"100%"}}>
     <input type="file"/>
    </div>
    <div class="file-path-wrapper">
    </div>
  </div><br/> */}
                            <div className="btn btn-primary btn-xl" style={{ width: "100%" }}>

                                <input type="file" accept="image/*" onChange={(e) => { this.handleImageUpload(e) }} />
                            </div>
                            <br /><br />
                            {this.state.isUploading && <div><LinearProgress variant="determinate" value={this.state.progress} /><br /><br /></div>}


                            <textarea required className="form-control" id="exampleFormControlTextarea1" rows="3" onChange={(e) => { this.setState({ desc: e.target.value }) }}></textarea><br />
                            {this.state.isUploading === false && <button className="btn btn-primary" style={{ marginLeft: "45%" }} type="button" onClick={this.addclue}>Add Clue</button>}
                            {this.state.descenter && <div style={{ color: "#000080", fontFamily: "Roboto", textAlign: "center" }}><p>Please Enter Some Description</p></div>}
                        </form>
                    </Modal.Body>
                    <Modal.Footer>

                        {this.state.isUploading === false && <button onClick={() => { this.setState({ shows: false }) }} className="btn btn-danger">Close</button>}
                    </Modal.Footer>
                </Modal>
                <EditClue
                    open={this.state.show}
                    title={this.state.title}
                    text={this.state.text}
                    user={this.props.user}
                    clue={this.state.clue}
                    userid={this.state.userid}
                    reload={this.getclues}
                />

<Modal
                    aria-labelledby="contained-modal-title-vcenter"
                    show={this.state.delete}
                    size='md'
                    onHide={() => { this.setState({ delete: false }) }}>
                    <Modal.Header>
                        <Modal.Title>Delete Clue</Modal.Title>
                    </Modal.Header>
                    <div><Modal.Body style={{ height: "10vh" }}><p>Are You Sure You Want To Delete This Clue?</p></Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-primary" onClick={() => { this.setState({ delete: false }) }}>
                                Close
          </button>
                            <button className="btn btn-danger" onClick={() => { this.deleteclue(this.state.clue) }}>
                                Delete
          </button>
                        </Modal.Footer></div>}
                </Modal>








            </div>
        )
    }
}
export default App;